import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { ArrowRecurringIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { textColorL2 } from '@calendly/ui/theme'

import { Layout } from 'components/layout'
import { useEventTypeContext } from 'features/event_type_provider'

import { HeaderWithIcon, PanelContentContainer, PanelContentHeader } from '../styles'
import { useAvailabilitySidePanelActions } from './available_hours/components/availability_side_panel'
import { ActiveHostSummaries } from './available_hours/components/availability_summary'
import { CalendarViewControl } from './available_hours/components/calendar_view_control'
import { MultiHostScheduleSelect } from './available_hours/components/multi_host_schedule_select'
import { EventTypeLevelAvailableHours } from './available_hours/event_type_level_available_hours'
import { BaseAvailability } from './base_availability'
import { PanelContentTitle } from './styles'

const HeaderPart = (props) => <Layout gap="4" align="center" {...props} />

export const MultiHostAvailability = ({ isReadOnly = false }) => {
  const { isSingleUseLink } = useEventTypeContext()
  const isDesktopUp = useDeviceType('isDesktopUp')
  const { toggleAvailabilitySidePanel } = useAvailabilitySidePanelActions()

  const { values: { userRuleType } } = useFormContext()
  const isExistingUserRuleType = userRuleType === 'existing'

  const handleOpenCalendar = () => toggleAvailabilitySidePanel({ formPath: 'eventTypeAvailability', format: 'calendar' })

  return (
    <BaseAvailability
      description={I18n.t('publisher.event_type_editor.sections.availability.hours.weekly_hours_for_all')}
    >
      <PanelContentContainer section>
        <PanelContentHeader withActions>
          <HeaderPart>
            <PanelContentTitle>
              {I18n.t('publisher.event_type_editor.sections.availability.schedule.title')}
            </PanelContentTitle>
          </HeaderPart>
          {!isExistingUserRuleType && isDesktopUp && !isSingleUseLink && (
            <HeaderPart>
              <CalendarViewControl onClick={handleOpenCalendar} />
            </HeaderPart>
          )}
        </PanelContentHeader>
        <MultiHostScheduleSelect isLocked={isSingleUseLink || isReadOnly} />
        {!isExistingUserRuleType && (
          <PanelContentHeader>
            <HeaderWithIcon>
              <ArrowRecurringIcon color={textColorL2} />
              <BodyText size="medium">
                {I18n.t('publisher.event_type_editor.sections.available_hours.weekly_hours')}
              </BodyText>
            </HeaderWithIcon>
            <BodyText size="x-small" color="muted">
              {I18n.t('publisher.event_type_editor.sections.availability.hours.weekly_hours_for_all')}
            </BodyText>
          </PanelContentHeader>
        )}
      </PanelContentContainer>
      {isExistingUserRuleType ? (
        <ActiveHostSummaries isReadOnly={isSingleUseLink} />
      ) : (
        <EventTypeLevelAvailableHours
          formPath="eventTypeAvailability"
          isMultiHost
          readOnly={isSingleUseLink || isReadOnly}
        />
      )}
    </BaseAvailability>
  )
}
